// extracted by mini-css-extract-plugin
export var button = "Button-module--button--v7hKg";
export var buttonVariant = "Button-module--buttonVariant--WSjop";